import React from "react";
import { Link } from "react-router-dom";
import { Box, Container, Grid, Typography, Paper, Button } from "@mui/material";
import { motion } from "framer-motion";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import InsightsIcon from "@mui/icons-material/Insights";

const OurServices = () => {
  const ClickHandler = () => window.scrollTo(10, 0);

  const categories = [
    {
      title: "Business Setup & Compliance",
      slug: "business-setup-compliance",
      intro:
        "We help global businesses build a successful presence in India, from entity structuring and incorporation to ongoing taxation and regulatory compliance.",
      icon: <VerifiedUserIcon sx={{ fontSize: 50 }} />,
      color: "#1a42a1",
    },
    {
      title: "Advisory & Deals",
      slug: "advisory-deals",
      intro:
        "A dedicated strategic vertical supporting capital decisions, business transformation, mergers, acquisitions, and high-impact value creation.",
      icon: <InsightsIcon sx={{ fontSize: 50 }} />,
      color: "#2b5ce2",
    },
  ];

  return (
    <Box component="section" sx={{ py: { xs: 4, md: 7 }, bgcolor: "#f8fbff" }}>
      <Container maxWidth="lg">
        <Box textAlign="center" mb={6}>
          <Typography
            variant="overline"
            sx={{
              color: "var(--primary-color)",
              fontWeight: 800,
              letterSpacing: 2,
              mb: 1,
              display: "block",
            }}
          >
            Our Services
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              color: "#222",
              fontFamily: "'Roboto Slab', serif",
              fontSize: { xs: "2rem", md: "3.5rem" },
              mb: 3,
            }}
          >
            What We <span style={{ color: "var(--primary-color)" }}>Offer</span>
          </Typography>
          <Typography
            sx={{
              color: "#666",
              maxWidth: "700px",
              mx: "auto",
              fontSize: "1.1rem",
              lineHeight: 1.8,
            }}
          >
            Specialized consulting and compliance solutions delivered through
            two dedicated verticals to power your business growth.
          </Typography>
        </Box>

        <Grid container spacing={6} justifyContent="center">
          {categories.map((cat, index) => (
            <Grid item xs={12} md={6} key={index} sx={{ display: "flex" }}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: index * 0.2 }}
                style={{ display: "flex", width: "100%" }}
              >
                <Paper
                  elevation={0}
                  sx={{
                    p: { xs: 4, md: 6 },
                    height: "100%",
                    width: "100%",
                    borderRadius: "40px",
                    bgcolor: "#fff",
                    border: "1px solid #eef",
                    position: "relative",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    boxShadow: "0 20px 40px rgba(26, 66, 161, 0.05)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 30px 60px rgba(26, 66, 161, 0.12)",
                      borderColor: cat.color,
                      "& .cat-icon": {
                        transform: "scale(1.1) rotate(5deg)",
                        color: cat.color,
                      },
                    },
                  }}
                >
                  <Box
                    className="cat-icon"
                    sx={{
                      width: 100,
                      height: 100,
                      mb: 4,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: `${cat.color}10`,
                      borderRadius: "30px",
                      color: cat.color,
                      transition: "all 0.4s ease",
                    }}
                  >
                    {cat.icon}
                  </Box>

                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 800,
                      mb: 3,
                      fontFamily: "'Roboto Slab', serif",
                      color: "#222",
                      fontSize: { xs: "1.75rem", md: "2.25rem" },
                    }}
                  >
                    {cat.title}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#666",
                      fontSize: "1.1rem",
                      lineHeight: 1.8,
                      mb: 5,
                      flexGrow: 1,
                    }}
                  >
                    {cat.intro}
                  </Typography>

                  <Link
                    onClick={ClickHandler}
                    to={`/service-group/${cat.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <Button
                      variant="contained"
                      endIcon={<ArrowForwardIcon />}
                      sx={{
                        bgcolor: cat.color,
                        color: "#fff",
                        px: 5,
                        py: 2,
                        borderRadius: "50px",
                        fontWeight: 700,
                        textTransform: "none",
                        fontSize: "1rem",
                        boxShadow: `0 10px 20px ${cat.color}33`,
                        "&:hover": {
                          bgcolor: cat.color,
                          filter: "brightness(0.9)",
                          boxShadow: `0 15px 30px ${cat.color}44`,
                        },
                      }}
                    >
                      Explore Vertical
                    </Button>
                  </Link>
                </Paper>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default OurServices;
